export const initialState = {
  loadingStatus: {
    bookAppointmentLoading: false,
  },
  error: '',
};
